module.exports = __webpack_public_path__ + "img/paypal.0d4ab545.svg";